var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg212Ts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 23.665C5.40237 22.4598 2 18.1419 2 13C2 6.92487 6.74949 2 12.6083 2C14.9052 2 17.0317 2.75697 18.7682 4.04345C19.9536 2.78539 21.6351 2 23.5 2C27.0898 2 30 4.91015 30 8.5C30 10.0673 29.4453 11.5051 28.5214 12.6277C29.4467 13.8256 30 15.3458 30 17C30 20.866 26.9776 24 23.2493 24C23.1658 24 23.0827 23.9984 23 23.9953V22H23.3029V21.9996C25.8359 21.9695 28 19.8105 28 17C28 14.1696 25.8053 12 23.2493 12C22.5272 12 21.8339 12.1732 21.2108 12.4855C21.1791 11.9037 21.0937 11.3367 20.9599 10.7899L20.9569 10.7911C20.0091 6.85004 16.5839 4 12.6083 4C7.92179 4 4 7.96046 4 13C4 17.0657 6.55261 20.4291 10 21.5772V23.665ZM27.0758 11.2324C27.6555 10.4748 28 9.52763 28 8.5C28 6.01472 25.9853 4 23.5 4C22.2266 4 21.0767 4.52892 20.2581 5.37905C21.4493 6.66438 22.3421 8.24924 22.821 10.0139C22.9626 10.0047 23.1054 10 23.2493 10C24.67 10 25.9882 10.4551 27.0758 11.2324ZM13.168 22.4453L17.168 16.4453L18.8321 17.5547L15.8685 22H19H20.9558L19.8107 23.5855L15.4773 29.5855L13.856 28.4145L17.0442 24H14H12.1315L13.168 22.4453Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg212Ts);
export default __webpack_public_path__ + "static/media/212ts.b6c9e21c9e136adf66e0d49e52076e50.svg";
export { ForwardRef as ReactComponent };